import { Button } from '@mui/material';

const CheckIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const CloseIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M15 5L5 15" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 5L15 15" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const resolveButtonConfig = (title, bgColor) => {
	const normalizedTitle = String(title ?? '')
		.trim()
		.toLowerCase();

	if (['yes', 'submit', 'confirm', 'ok'].includes(normalizedTitle)) {
		return {
			icon: <CheckIcon />,
			backgroundColor: '#155DFC',
			hoverBackgroundColor: '#0F4CD6',
		};
	}

	if (['no', 'cancel', 'close'].includes(normalizedTitle)) {
		return {
			icon: <CloseIcon />,
			backgroundColor: '#E7000B',
			hoverBackgroundColor: '#D92D20',
		};
	}

	return {
		icon: null,
		backgroundColor: bgColor ?? '#155DFC',
		hoverBackgroundColor: bgColor ?? '#155DFC',
	};
};

const YesNoButton = ({ type = 'button', handleClick, bgColor, title }) => {
	const { icon, backgroundColor, hoverBackgroundColor } = resolveButtonConfig(title, bgColor);

	return (
		<Button
			type={type}
			startIcon={icon}
			variant="contained"
			onClick={handleClick}
			sx={{
				px: 2,
				gap: 0.75,
				height: '36px',
				minWidth: '84px',
				fontWeight: 500,
				fontSize: '14px',
				boxShadow: 'none',
				lineHeight: '20px',
				borderRadius: '10px',
				color: 'common.white',
				textTransform: 'none',
				bgcolor: backgroundColor,
				transition: 'all 0.2s ease',

				'& .MuiButton-startIcon': {
					margin: 0,
				},

				'&:hover': {
					boxShadow: 'none',
					bgcolor: hoverBackgroundColor,
				},
			}}
		>
			{title}
		</Button>
	);
};

export default YesNoButton;
